import { constraints, datatypes, inputTypes } from "data/globalData";

export const tableColumns = {
	trims_id: {
		name: "Trims Id",
		key: "trims_id",
		input_type: inputTypes.SELECT.key,
		data_type: datatypes.STRING.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	category: {
		name: "Category",
		key: "category",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.STRING.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	description: {
		name: "Description",
		key: "description",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.STRING.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	consumption: {
		name: "Consumption",
		key: "consumption",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.NUMBER.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	consumption_unit: {
		name: "Cosumption Unit",
		key: "consumption_unit",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.STRING.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	price: {
		name: "Price",
		key: "price",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.NUMBER.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	value: {
		name: "Value",
		key: "value",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.NUMBER.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	supplier: {
		name: "Supplier",
		key: "supplier",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.STRING.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
};

export const dummyPackingTrimsTableData = [
	{
		id: 1,
		trims_id: "1234",
		category: "Main Label",
		description: "RAREISM RUBY LOOP MAIN LABEL WITH RED STONE LBL RR-1683-B32950-A-BLACK WITH RED -CENTER FOLD",
		consumption: 2.2,

		price: 155.0,
		value: 341,
		supplier: "MANOHAR FILAMENT",
	},
	{
		id: 2,
		trims_id: "1234",
		category: "Size Label",
		description: "RAREISM SIZE LABEL LBL-RR-1003-WS56-J (CREAM WITH BEIGE (2.8X1CM +CENTER FOLD)",
		consumption: 1.53,

		price: 92.0,
		value: 140.76,
		supplier: "MANOHAR FILAMENT",
	},
];

export const defaultTotalRow = {
	id: "TOTAL",
	trims_id: "TOTAL",
	category: "Packing Trims",
	price: 155.0,
	value: 341,
};

export const checkForTotalColumn = (row) => {
	if (row.id === "TOTAL" || row.trims_id === "TOTAL" || row?.[tableColumns.category.key] === "TOTAL") return true;
	return false;
};

export const calculateTotalRow = (allRows) => {
	let price = 0;
	let value = 0;
	allRows?.forEach((row) => {
		if (!isNaN(row?.[tableColumns.price.key])) price += +row?.[tableColumns.price.key];
		if (!isNaN(row?.[tableColumns.value.key])) value += +row?.[tableColumns.value.key];
	});
	return { ...defaultTotalRow, [tableColumns.price.key]: price, [tableColumns.value.key]: value };
};

// Packing trims source data
const packingTrimsData = [
	{ category: "HANG TAG", description: "RAREISM HANGTAG RRHGT-057 WITH STRING+ PVC TAG" },
	{ category: "TAG", description: "RAREISM LINEN TAG HGT-RSM-7003" },
	{ category: "TISSUE", description: "RAREISM PLAIN SPECIAL QUALITY TISSUE PAPER 13X18 INCHES" },
	{ category: "POLY BAG", description: 'RAREISM TOPS/DRESSES COMPOSTABLE 20MICRON POLYBAG 12"(W)X15"(L)+F+SAT WITH SIZE PRINT' },
	{ category: "POLY BAG", description: 'RAREISM BOTTOM COMPOSTABLE 30MICRON POLYBAG 12"(W)X15"(L)+F+SAT WITH SIZE PRINT' },
];

// function to generate unique numeric IDs per load
const generateNumericId = () => Math.floor(Date.now() + Math.random() * 10000);

// format to your target structure
export const packingTrimsPrefilledData = packingTrimsData.map((item) => ({
	id: generateNumericId(),
	trims_id: "",
	category: item.category,
	description: item.description,
	consumption: 0,
	price: 0,
	value: 0,
	supplier: "",
}));
